import React from 'react';
import { EditPage } from '@components/common';
import CategoryForm from '../CategoriesPage/CategoryForm';

const CategoryEditPage = () => {
    return (
        <EditPage
            modelName="categories"
            FormComponent={CategoryForm}
        />
    );
};

export default CategoryEditPage;
